(function () {
  'use strict';

  angular
      .module('tfc.retailer.Consumer', [])
      .constant('ConsumerReportKeys', [
        'ConsumerProfile'
      ])
      .config(config);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('consumerReports', {
          abstract : true,
          parent : 'pageWithMenu',
          url : '/consumer?brandKey&transaction&region',
          data : {
            // TODO: This will change once we figure out the menu organization
            auth : { privilege : 'report.ConsumerProfile' },
            requireTerms:true
          },
          template : '<ui-view></ui-view>'
        })
        .state('consumerReports.all', {
          url : '/all',
          templateUrl : 'Consumer/ConsumerReports.tmpl.html',
          controller : 'ConsumerReportsCtrl as vm'
        })
        .state('consumerReports.ConsumerProfile', {
          url : '/ConsumerProfile',
          templateUrl : 'Consumer/ConsumerProfile.tmpl.html',
          data:{
            title:'Demographic & Body Shape',
            path:'consumer/ConsumerProfile'
          },
          params: {
            gender: null
          },
          controller : 'ConsumerProfileCtrl as vm',
          resolve : {
            selectedBrandKey: function(BrandReports, $stateParams){
              return BrandReports.selectedBrandKey($stateParams.brandKey).then(function(selectedBrandKey){
                $stateParams.brandKey = selectedBrandKey;
                return selectedBrandKey;
              });
            },
            filters: function($stateParams, ConsumerReports, selectedBrandKey, activityRegion) {
              return activityRegion(function() {
                return ConsumerReports.getConsumerProfileFilters(selectedBrandKey)
              },$stateParams.transaction, $stateParams.region);
            },
            genderData : function(ConsumerReports, filters, BrandReports, $stateParams, Enums, selectedBrandKey) {
              var transaction = filters.getSelected();
              var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
              return ConsumerReports.getGenderAggregations(selectedBrandKey, region, transaction && transaction.getLabel());
            },
            stateParamsGender : function($stateParams, genderData) {
              if(!$stateParams.gender && genderData.womenPercent) {
                return $stateParams.gender = "Female";
              } else if(!$stateParams.gender && genderData.menPercent) {
                  return $stateParams.gender = "Male";
              } else {
                return $stateParams.gender;
              }
            },
            ageData : reportData('getAgeAggregations'),
            heightData : reportData('getHeightAggregations'),
            weightData : reportData('getWeightAggregations'),
            inseamData : reportData('getInseamAggregations'),
            footLengthData : reportData('getFootLengthAggregations'),
            bustSizeData : reportData('getBustSizeAggregations'),
            userBrands : function (ConsumerReports) {
              return ConsumerReports.findBrandNames();
            },
            aggregationLogDetails : function(BrandReports) {
              return BrandReports.getDashboardAggregationLogDetails('ConsumerProfile');
            }
          }
        });

    function reportData(fnName) {
      // We can't just return function here, because ngInject doesn't work in that case, and
      // ui-router does not adhere to the strictDi setting, so we didn't know until we got to staging
      // @ngInject
      function resolver(ConsumerReports, stateParamsGender, selectedBrandKey, filters) {
        var transaction = filters.getSelected();
        var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
        if(stateParamsGender) {
          return ConsumerReports[fnName](selectedBrandKey, stateParamsGender, region, transaction && transaction.getLabel());
        } else {
          return [];
        }
      }
      return resolver;
    }

  }

})();